import { useState, useRef, useEffect } from 'react';
import { Lock, Gift } from 'lucide-react';
import { trackClick } from '@/lib/track';

const GIFTS_LIST = [
  { image: "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/bgvb9t31_9CD78097-A8E1-4665-AE09-EC378065E18D.jpeg", title: "Exclusive portrait", locked: false },
  { image: "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/lmhoy425_Satya_03.png", title: "Satya — behind the scene", locked: true },
  { image: "https://customer-assets.emergentagent.com/job_avinash-studio/artifacts/r1kcbxoe_DSC_7296.jpeg", title: "Unscripted moment", locked: false },
];

export default function GiftsSection() {
  const [unlocked, setUnlocked] = useState({});
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) e.target.querySelectorAll('.reveal-el').forEach(c => c.classList.add('visible')); }, { threshold: 0.1 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const handleAccept = (i) => {
    setUnlocked(prev => ({ ...prev, [i]: true }));
    trackClick({ film: 'gift', platform: 'website', action: 'unlock', section: 'gifts' });
  };

  return (
    <section id="gifts" data-testid="gifts-section" ref={ref} className="py-24 md:py-40 px-5 md:px-10 lg:px-20 bg-gifts">
      <p className="reveal-el font-['Cormorant_Garamond'] text-xs tracking-[0.3em] uppercase mb-4" style={{ color: 'var(--gold)' }}>Gifts</p>
      <h2 className="reveal-el font-['Playfair_Display'] italic text-3xl md:text-4xl font-normal mb-12 md:mb-16" style={{ color: 'var(--warm-cream)' }}>A gift for being here.</h2>

      <div className="reveal-el grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {GIFTS_LIST.map((gift, i) => (
          <div key={i} className="relative aspect-[3/4] overflow-hidden rounded-sm group cursor-pointer" onClick={() => !gift.locked && !unlocked[i] && handleAccept(i)}>
            <img src={gift.image} alt={gift.title} className="w-full h-full object-cover object-top transition-all duration-[1.5s]"
              style={{ filter: gift.locked ? 'blur(8px) brightness(0.4)' : unlocked[i] ? 'none' : 'brightness(0.4)' }} />
            {gift.locked && (
              <div className="locked-overlay">
                <Lock className="w-5 h-5" style={{ color: 'var(--gold)' }} strokeWidth={1.5} />
                <span className="font-['Inter'] text-[9px] tracking-[0.2em] uppercase" style={{ color: 'var(--gold)' }}>Inside Only</span>
              </div>
            )}
            {!gift.locked && !unlocked[i] && (
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="font-['Inter'] text-[10px] tracking-[0.2em] uppercase px-6 py-3 rounded-full" style={{ color: 'var(--warm-cream)', border: '1px solid rgba(201,168,76,0.25)', background: 'rgba(10,10,10,0.5)' }}>Accept</span>
              </div>
            )}
            {unlocked[i] && (
              <div className="absolute inset-3 pointer-events-none" style={{ border: '1px solid rgba(201,168,76,0.15)' }} />
            )}
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="font-['Playfair_Display'] italic text-sm" style={{ color: 'var(--warm-cream)' }}>{gift.title}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
